import { PropsWithChildren } from 'react';

export const EmptyFormBlockWrapper = (props: PropsWithChildren) => {
    return <>{props.children}</>;
};
